import { FC, useState } from 'react';
import { css } from '@emotion/react';
import { ChatBotV1 } from '@frontend/api-chat-bot';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, useAlert } from '@frontend/design-system';

export const MessageFeedback: FC<{ messageId: string }> = ({ messageId }) => {
  const [feedback, setFeedback] = useState<'positive' | 'negative'>();
  const alerts = useAlert();
  const { t } = useTranslation('aiOnboarding');

  const { mutate: submitFeedback, isLoading: isMutating } = ChatBotV1.Mutations.useFeedbackMutation({
    options: {
      onSuccess: (_, request) => {
        setFeedback(request.rating === 'positive' ? 'positive' : 'negative');
        alerts.success(t('Thank you for your feedback!'));
      },
      onError: () => {
        alerts.error(t('Something went wrong. Please try again.'));
      },
    },
  });

  return (
    <div css={styles.feedbackBar}>
      <Button
        iconName='feedback-bad-small'
        size='small'
        variant='secondary'
        aria-label='Not Helpful'
        disabled={isMutating}
        onClick={() =>
          submitFeedback({
            sessionId: messageId,
            rating: 'negative',
          })
        }
        css={feedback === 'negative' ? styles.negativeIcon : undefined}
      />
      <Button
        iconName='feedback-small'
        size='small'
        variant='secondary'
        aria-label='Helpful'
        disabled={isMutating}
        onClick={() =>
          submitFeedback({
            sessionId: messageId,
            rating: 'positive',
          })
        }
        css={feedback === 'positive' ? styles.positiveIcon : undefined}
      />
    </div>
  );
};

const styles = {
  feedbackBar: css`
    display: flex;
    margin-top: ${theme.spacing(0.5)};
    align-self: flex-end;
  `,
  positiveIcon: css`
    background-color: ${theme.colors.success10};
  `,
  negativeIcon: css`
    background-color: ${theme.colors.critical10};
  `,
};
